import { IsiGridViewContext } from "../IsiGridViewContext";
import { IsiAssociatedView } from "../IsiAssociatedView.component";
import { IsiDtoAssociatedViewClientState } from "../../../../../Dtos/Isilog.IsiFramework.IsiDataTransferObject.IsiAssociatedView";
import { IIsiComponentManager } from "../../../Core/Manager/IIsiComponentManager";

export class IsiAssociatedViewContext<TComponent extends IsiAssociatedView> extends IsiGridViewContext<TComponent> {

    constructor(componentManager: IIsiComponentManager, componentId: string, state: IsiDtoAssociatedViewClientState) {
        super(componentManager, componentId, state);
    }
}